import React from 'react';
import { isBreakpointSmallOrBelow, useBreakpoint } from '@noths/polaris-client-ribbons-base';

import type { ProductMediaCarouselProps } from './ProductMediaCarousel';
import { ProductMediaCarousel } from './ProductMediaCarousel';

type ProductMediaCarouselWithBreakpointProps = Omit<
  ProductMediaCarouselProps,
  | 'mobileEdgeToEdge'
  | 'showArrows'
  | 'showDots'
  | 'showFavouriteButton'
  | 'showNumberOfSlides'
  | 'showsAsGrid'
>;

export const ProductMediaCarouselWithBreakpoint = (
  props: ProductMediaCarouselWithBreakpointProps,
) => {
  const breakpoint = useBreakpoint({ initializeWithLarge: true });
  const showsAsGrid = !isBreakpointSmallOrBelow(breakpoint);

  return (
    <ProductMediaCarousel
      {...props}
      mobileEdgeToEdge
      showDots
      showFavouriteButton
      showNumberOfSlides
      showsAsGrid={showsAsGrid}
    />
  );
};
